
import http from '@/http/index.js'

import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      platform: 'Web API',
      platformList: null,
      keyOptionList: null,
      oriKeyList: null
    }
  },
  methods: {
    getKeyList() {
      this.keyOptionList = this.oriKeyList.filter(item => {
        return item.platformName === this.platform
      });
      if (this.queryForm && this.queryForm.key) {
        this.queryForm.key = null
        this.queryForm.api = null
      }
    }

  },
  async created() {
    this.platformList = await http.key.platform()
    const res = await http.key.getList();
    this.oriKeyList = cloneDeep(res)
    this.getKeyList()
  }
}
